<script>
    export default {
        data() {
            return {
                course: ''
            }
        },
        created() {
            this.$bus.$on('update-promotion', this.onUpdate)
        },
        methods: {
            onUpdate(course) {
                this.$set(this, 'course', course)
            },
            onClose() {
                this.$set(this, 'course', '')
            },
            onChoisePromotion(promo) {
                location.href = `/corsi/${this.course.slug}/create-promotion?promo=${promo}`;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CoursePromotionModal.vue